import { t } from "@lingui/macro";
import { InvoiceTypeEnum } from "@src/components/modules/invoices/Create/store";
import { dateTime } from "@src/utils/formatters";
import cx from "classnames";
import { differenceInCalendarDays } from "date-fns";
import type React from "react";
import type { FC } from "react";
import { useStore } from "../../../store";
import type { ColumnProps } from ".";
import { EditDateWrapper } from "./edit-date-wrapper";

export const DueDate: FC<React.PropsWithChildren<ColumnProps>> = ({ row }) => {
  const store = useStore();
  const dueDate = new Date(row.due_date);
  const daysDiff = differenceInCalendarDays(new Date(), dueDate);
  const notPaid = !row.paid_at;

  return (
    <EditDateWrapper
      dataComponentName="due-date-edit-date-trigger"
      row={row}
      invoiceType={InvoiceTypeEnum.Proforma}
      isDisabled={!row.due_date}
      onUpdate={store.proformaInvoicesRefetch}
      modalStore={store.changeDatesModalStore}
    >
      <div
        className={cx({
          "text-red": daysDiff > 0 && notPaid,
        })}
      >
        {dateTime.format(dueDate)}
        {daysDiff > 0 && notPaid && (
          <span className="block">
            ({daysDiff} {t`days before`})
          </span>
        )}
      </div>
    </EditDateWrapper>
  );
};
